module.exports = __webpack_public_path__ + "img/sankaku_91_red.6523b8de.png";